// Deps
import { createComponent } from "react-fela";
import { gutters } from "~/styleguide";
import { fluid } from "~/styleguide/utils";
import { textStyles, fonts } from "~/styleguide/typography";

// Components
import { ContentMaxWidth } from "~/components/layout/max-width";
import PostContent from "~/components/shared/post-content";

/**
 * HTML Content block
 *
 * Supports arbitray HTML input.
 * @param {Object} props
 */
export default function HTML({ block }) {
    const {
        heading,
        html_content,
        layout = "regular",
        default_padding = true,
        anchor_id,
    } = block;

    if (!html_content) return null;

    const executeScripts =
        typeof window !== "undefined" && window.location.pathname === "/_preview";

    return (
        <Container
            className="module-html"
            id={anchor_id}
            defaultPadding={default_padding}
        >
            <ContentMaxWidth
                extend={{
                    extend: [
                        {
                            // Clear the max-width settings if layout is `wide`
                            condition: layout === "wide",
                            style: {
                                maxWidth: "auto",
                            },
                        },
                    ],
                }}
            >
                {/* Heading  */}
                {heading && <Heading dangerouslySetInnerHTML={{ __html: heading }} />}

                {/* Content */}
                <PostContent
                    content={html_content}
                    executeScripts={executeScripts}
                    largeHeading={true}
                />
            </ContentMaxWidth>
        </Container>
    );
}

// Empty container for the module
const Container = createComponent(
    ({ defaultPadding }) => ({
        // So ad-hoc content can be absolute positioned easily.
        position: "relative",

        extend: [
            {
                // Add default module padding to container, if flag is set
                condition: defaultPadding,
                style: {
                    extend: [
                        fluid("paddingH", gutters.default),
                        fluid("paddingV", gutters.vertical),
                    ],
                },
            },
        ],
    }),
    "div",
    ["id"]
);

const Heading = createComponent(
    () => ({
        ...fonts.aeonikBold,
        ...textStyles.heading2,
        textAlign: "center",
    }),
    "h3",
    ["dangerouslySetInnerHTML"]
);
